import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { Row, Col, Button, Modal, Form, Card } from "react-bootstrap";
import Axios from "axios";
import { useNavigate } from "react-router-dom";

//ACTIONS
import * as GS_navSettingsActions from "../../../../../store/actions/globalSettings/GS_navSettings";
import * as PlannerActions from "../../../../envStore/actions/planner";

//STYLES
import * as ControllerStyles from "../styles/controller";

function Controller() {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const [newPlanModal, setNewPlanModal] = useState({
        open: false,
        name: "",
        error: false
    });
    const [modal, setModal] = useState({
        open: false,
        header: "",
        message: ""
    });
    const [plans, setPlans] = useState([]);

    function handleModalClose() {
        setModal((prevState) => {
            return { ...prevState, open: false };
        });
    }

    useEffect(() => {
        dispatch(GS_navSettingsActions.UpdateTitle("Planner"));
        dispatch(GS_navSettingsActions.UpdateSelected("Features"));
        dispatch(GS_navSettingsActions.UpdateSubSelected("Planner"));

        loadPlans();
    }, []);

    function loadPlans() {
        Axios.post("/pods/plannerAdmin/getPlans")
            .then((res) => {
                const data = res.data;
                if (data.error == "null") {
                    setPlans(data.plans);
                }
            })
            .catch((err) => console.log(err));
    }

    function handleNewPlanModalClose() {
        setNewPlanModal((prevState) => {
            return { ...prevState, open: false };
        });
    }

    function handleNewPlanModalOpen() {
        Axios.post("/pods/plannerAdmin/checkPlannerMaster")
            .then((res) => {
                const data = res.data;
                if (data.error == "null") {
                    setNewPlanModal((prevState) => {
                        return { ...prevState, open: true };
                    });
                } else {
                    setModal({
                        header: "New Plan",
                        message: data.message,
                        open: true,
                        error: false
                    });
                }
            })
            .catch((err) => console.log(err));
    }

    function handleTextChange(event) {
        const { value } = event.target;

        let error = false;

        if (value == "") {
            error = true;
        }

        setNewPlanModal((prevState) => {
            return { ...prevState, name: value, error: error };
        });
    }

    function handleAddNewPlan() {
        if (newPlanModal.name == "") {
            setNewPlanModal((prevState) => {
                return { ...prevState, error: true };
            });
        } else {
            const data = { title: newPlanModal.name };
            Axios.post("/pods/plannerAdmin/addPlan", data)
                .then((res) => {
                    const data = res.data;
                    if (data.error == "Yes") {
                        setModal({ header: "New Plan", message: data.message, open: true });
                    } else {
                        navigate(`./plan/${data.uuid}`);
                    }
                })
                .catch((err) => console.log(err));
        }
    }

    function handlePlanClick(uuid) {
        navigate(`./plan/${uuid}`);
    }

    return (
        <div style={ControllerStyles.body}>
            <Row>
                <Col style={ControllerStyles.newPlanBtn}>
                    <Button onClick={handleNewPlanModalOpen}>New Plan</Button>
                </Col>
            </Row>
            <Row>
                <Col style={ControllerStyles.topRowTitles}>
                    <Card style={ControllerStyles.topTitles}>
                        <Card.Body>
                            <Row>
                                <Col>Title</Col>
                            </Row>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
            <Row>
                <Col>
                    <div style={ControllerStyles.plansBox}>
                        {plans.map((plan, index) => {
                            return (
                                <div key={index}>
                                    <Card style={ControllerStyles.singlePlan} onClick={handlePlanClick.bind(this, plan.uuid)}>
                                        <Card.Body>
                                            <Row>
                                                <Col>{plan.title}</Col>
                                            </Row>
                                        </Card.Body>
                                    </Card>
                                    <br />
                                </div>
                            );
                        })}
                    </div>
                </Col>
            </Row>
            <Modal show={newPlanModal.open} onHide={handleNewPlanModalClose}>
                <Modal.Header closeButton>
                    <Modal.Title>New Plan</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    Name:
                    <Form.Group>
                        <Form.Control
                            isInvalid={newPlanModal.error ? true : false}
                            type="text"
                            value={newPlanModal.name}
                            onChange={handleTextChange}
                        />
                        <Form.Control.Feedback type="invalid">Please enter a plan name!</Form.Control.Feedback>
                    </Form.Group>
                </Modal.Body>
                <Modal.Footer>
                    <Button onClick={handleAddNewPlan}>ADD</Button>
                    <Button onClick={handleNewPlanModalClose}>Close</Button>
                </Modal.Footer>
            </Modal>
            <Modal show={modal.open} onHide={handleModalClose}>
                <Modal.Header closeButton>
                    <Modal.Title>{modal.header}</Modal.Title>
                </Modal.Header>
                <Modal.Body>{modal.message}</Modal.Body>
                <Modal.Footer>
                    <Button onClick={handleModalClose}>Close</Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
}

export default Controller;
